import React from "react";
import { FormControl, FormGroup, Button, Glyphicon, InputGroup } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";

export default class PayrollStaffAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            selectedText: ''
        };

        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.dropdownContent = null;
        this.getHighlightedText = this.getHighlightedText.bind(this);
        this.search = null;
        this.input = null;
        this.onSearchClick = this.onSearchClick.bind(this);
    }    

    componentDidMount() {
        this.setState({
            items: this.props.items,
            selectedText: this.props.defaultValue
        });
    }

    componentWillReceiveProps(currProps) {
        this.dropdownContent.className = this.dropdownContent.className.replace('show', '');
    }

    onClick(event) {
        if (this.dropdownContent.className.indexOf('show') < 0) {
            this.dropdownContent.className = this.dropdownContent.className + ' show';
        }
        
        this.search.className = 'glyphicon glyphicon-remove-sign';
        this.onKeyUp(event);
    }

    onKeyUp(event) {
        let value = event.target.value.trim().toLowerCase();
        let items = this.props.items.filter(x => x.fullName.trim().toLowerCase().indexOf(value) > -1);

        this.setState({
            items: items
        });
    }

    onSelect(item) {
        if (this.props.onChange) {
            this.props.onChange("associateName", item.fullName, this.props.onSearch);
        }

        this.dropdownContent.className = this.dropdownContent.className.replace('show', '');
        this.input.value = item.fullName;
        this.input.blur();
    }

    onBlur(event) {
        const self = this;

        setTimeout(function() {
            var inputFocused = $('#' + self.props.id + '-input').is(':focus');
            
            if (inputFocused == false) {
                self.dropdownContent.className = self.dropdownContent.className.replace('show', '');
                self.props.onChange("associateName", self.input.value.trim(), self.props.onSearch);
            }
            else {
                self.dropdownContent.className = self.dropdownContent.className + ' show'; 
            }

            setTimeout(function() {
                if (inputFocused == true) {
                    self.search.className = 'glyphicon glyphicon-remove-sign';
                }
                else {
                    self.search.className = 'glyphicon glyphicon-search';
                }
            }, 100);
        }, 10);
    }

    getHighlightedText(text) {
        var textToSearch = $('#' + this.props.id + '-input').val().trim().toLowerCase();
        var result = text;

        if (textToSearch != '') {
            result = result.replace(RegExp(textToSearch + "(?![^<>]*>)", "gi"), function(e) {
                return '<b>' + e + '</b>';
            });
        }
        
        return result;
    }

    onSearchClick() {
        const self = this;

        if (this.search.className.indexOf('glyphicon-remove-sign') > -1) {
            setTimeout(function() {
                $('#' + self.props.id + '-input').val('');
                var items = JSON.parse(JSON.stringify(self.props.items));

                self.setState({
                    items: items
                });

                $('#' + self.props.id + '-input').focus();
                self.search.className = 'glyphicon glyphicon-remove-sign';
            }, 10);
        }
        else {
            setTimeout(function() {
                $('#' + self.props.id + '-input').focus();
            }, 10);
        }
    }

    render() {
        var rows = [];
        
        const self = this;

        this.state.items.map(function (item, i) {
            let p = item; 
            rows.push(<a key={p.peopleId} href="javascript:void(0)" onMouseDown={() => self.onSelect(item)} className={this.state.selectedText}>
                <div className="item-name" dangerouslySetInnerHTML={ { __html: self.getHighlightedText(p.fullName) } }></div>
                </a>);
        }, this);

        return (
            <div className="ap-staff-autocomplete">
                <FormGroup className="form-group payroll" validationState={null}>
                    <InputGroup>
                        <FormControl
                            id={this.props.id + '-input'}
                            type="text"
                            onKeyUp={this.onKeyUp}
                            className="input payroll"
                            placeholder="Type staff's name"
                            onBlur={this.onBlur}
                            inputRef={ref => this.input = ref} 
                            onFocus={this.onClick} />
                        <InputGroup.Addon>
                            <div id={this.props.id + '-remove'} className="glyphicon glyphicon-search" ref={ref => this.search = ref} onMouseDown={this.onSearchClick}></div> 
                        </InputGroup.Addon>
                    </InputGroup>
                </FormGroup>
                <div id={this.props.id + '-dropdown-content'} className="dropdown-content" ref={ref => this.dropdownContent = ref}>
                    <div id={this.props.id + '-items-container'} className="items-container">
                        {rows}
                    </div>
                </div>
            </div>
        );
    }
}